module.exports = __webpack_public_path__ + "img/menucn-5-2.f6178694.svg";